import React from 'react'
import  { useState } from 'react';
import Styles from "../../Styles/DashBoard.module.css"
import TopBar from "../../Components/LayoutWapper/Global/TopBar";
import Sidebar from "../../Components/LayoutWapper/Global/SideBar";
import Data1 from "../../Components/Myjobs/Data1";
import Data2 from "../../Components/Myjobs/Data2";
import Data3 from "../../Components/Myjobs/Data3";
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';





function Index() {
        
  const [activeTab, setActiveTab] = useState("tab1");
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  function toggleSidebar() {
    setIsSidebarOpen(!isSidebarOpen);
  }


  // handle tab switching
  const handleTab1 = () => {
    setActiveTab("tab1");
  };

  const handleTab2 = () => {
    setActiveTab("tab2");
  };
  const handleTab3 = () => {
    setActiveTab("tab3");
  };







  return  (
      <div className={Styles.container}>
      <TopBar  toggleSidebar={toggleSidebar}/>
      <div className={Styles.main} >
       <div className={Styles.context} >
       <div className={Styles.nav}>
       {isSidebarOpen && <Sidebar />}
       </div>
       <div className={Styles.center}>
        <div className={Styles.info}>
        <div className={Styles.Header}>
         <h1>My Jobs </h1> 
         <p>Jobs based on your search and profile</p>
        </div>
          <div className={Styles.jobcontainer} >
            <div className={Styles.col1} >
              <div className={Styles.card} id={Styles.card}>
             <div className={Styles.selectjob}>
              <div className={Styles.jobsection}>
                <div className={Styles.section1}>
                 <div className={Styles.subsection}>
                  <div  
                   className={activeTab === "tab1" ? Styles.active : ""}
                   onClick={handleTab1}   
                  id={Styles.jobscards}  
                  >
                    <div className={Styles.carddetails}>
                     <ul>
                      <li className={Styles.head} >UI/UX Designer</li>
                      <li>Cdlp Hub Ltd</li>
                      <li>Ibadan</li>
                      <li>On-site</li>
                      <li className={Styles.tail}>Posted 2 days ago</li>
                     </ul>
                     <div className={Styles.infolist} id={Styles.infolist}>
                       <BusinessCenterOutlinedIcon sx={{ width:"16.67px", height:"15.83px" , color:"rgba(243, 114, 63, 1)"}}/>
                        <p>Fulltime</p>
                     </div>
                    </div>
                  </div>
                  <div 
                  className={activeTab === "tab2" ? Styles.active : ""}
                  onClick={handleTab2}
                  id={Styles.jobscards} >
                   <div className={Styles.carddetails}>
                   <ul>
                      <li className={Styles.head}>Front-end Developer</li>
                      <li>Cdlp Hub Ltd</li>
                      <li>Ibadan</li>
                      <li>On-site</li>
                      <li className={Styles.tail}  >Posted 2 days ago</li>
                     </ul> 
                     <div className={Styles.infolist} id={Styles.infolist2} >
                       <BusinessCenterOutlinedIcon sx={{ width:"16.67px", height:"15.83px" , color:"rgba(243, 114, 63, 1)"}}/>
                        <p>contract</p>
                     </div>
                  </div>
                  </div>
                  <div 
                  className={activeTab === "tab3" ? Styles.active : ""}
                  onClick={handleTab3}
                  id={Styles.jobscards}>
                  <div className={Styles.carddetails} >
                  <ul>
                      <li className={Styles.head} >Front-end Developer</li>
                      <li>Cdlp Hub Ltd</li>
                      <li>On-site</li>
                      <li>Cdlp Hub Ltd</li>
                      <li className={Styles.tail}  >Posted 2 days ago</li>
                     </ul>
                     <div className={Styles.infolist} id={Styles.infolist2} >
                       <BusinessCenterOutlinedIcon sx={{ width:"16.67px", height:"15.83px" , color:"rgba(243, 114, 63, 1)"}}/>
                        <p>contract</p>
                     </div>
                  </div>
                 </div>
                 </div>
                </div>
                <div className={Styles.section2}>
                <div className={Styles.subsec2}>
                {activeTab === "tab1" ? <Data1/> : activeTab === "tab2" ? <Data2/> : <Data3/>}
                </div>
                </div>
              </div>
             </div>
              </div>
            </div>
          </div>
          </div>
          </div>
         </div>
       </div> 
       </div>
      
  )
}

export default Index;